import React from 'react';

import { LeftArrowIcon } from '../../icons';
import { OmitStrict } from '../../types';
import Button, { ButtonProps } from '../Button';

type Props = OmitStrict<ButtonProps, 'size'>;

const WizardBackButton: React.FC<Props> = props => (
  <Button icon={LeftArrowIcon} iconPosition="left" variant="text" {...props} />
);

export default WizardBackButton;
